import styled from 'styled-components';

import { breakpoints, media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { Title } from '@/shared/uikit/Title';
import { Button } from '@/shared/uikitV2/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 24px;
  font-size: 14px;
  overflow: auto;

  ${media.md}, ${breakpoints.sm} {
    max-height: calc(100dvh - 260px);
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding: 16px 0 0 0;

  ${media.md}, ${breakpoints.sm} {
    flex-direction: column-reverse;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
  row-gap: 24px;

  ${media.md}, ${breakpoints.sm} {
    grid-template-columns: auto;
  }
`;

export const Form = styled.form`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const CharacterCount = styled.span`
  display: block;
  font-size: 12px;
  color: ${COLORS.systemDark200};
  margin-top: 4px;
  text-align: right;
  position: absolute;
  right: 0;
`;

export const AttachmentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Count = styled.span`
  color: ${COLORS.systemDark200};
`;

export const FileWrapper = styled.div`
  padding-block: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DocumentTitle = styled(Title)`
  flex: 1;
`;

export const ButtonDelete = styled(Button)`
  &&& {
    color: ${COLORS.systemDark200};
    width: 32px;
    height: 32px;

    &:hover {
      color: ${COLORS.systemDark300} !important;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RowText = styled.p`
  font-weight: 700;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const MaxFilesText = styled.p`
  text-align: center;
  color: ${COLORS.systemDark300};
`;

export const FileTypeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${COLORS.systemDark200};
  border-radius: 4px;
  width: 28px;
  height: 36px;
  color: ${COLORS.white};
  position: relative;
  flex-shrink: 0;

  &.isExternal {
    background: ${COLORS.systemSky300};
  }
`;
